module.exports = __webpack_public_path__ + "img/zhuxinsuanjingji-qrcode.7ae1ef8c.png";